<template>
  <svg :class="className" xmlns="http://www.w3.org/2000/svg">
    <title v-if="title">{{ title }}</title>
    <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
export default {
  name: "svg-icon",

  props: {
    name: {
      type: String,
      required: true
    },

    title: {
      type: String,
      default: null
    }
  },

  computed: {
    iconPath() {
      return require(`@v2/shared/assets/icons/${this.name}.svg`).default.url;
    },

    className() {
      return "svg-icon svg-icon--" + this.name;
    }
  }
};
</script>

<style>
.svg-icon {
  fill: currentColor;
}
</style>
